import createIcon from '../../createIcon';

/**
 * @component @name GpsNotFixed
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuOTQgMTFDMjAuNDggNi44MyAxNy4xNyAzLjUyIDEzIDMuMDZWMUgxMVYzLjA2QzYuODMgMy41MiAzLjUyIDYuODMgMy4wNiAxMUgxVjEzSDMuMDZDMy41MiAxNy4xNyA2LjgzIDIwLjQ4IDExIDIwLjk0VjIzSDEzVjIwLjk0QzE3LjE3IDIwLjQ4IDIwLjQ4IDE3LjE3IDIwLjk0IDEzSDIzVjExSDIwLjk0Wk0xMiAxOUM4LjEzIDE5IDUgMTUuODcgNSAxMkM1IDguMTMgOC4xMyA1IDEyIDVDMTUuODcgNSAxOSA4LjEzIDE5IDEyQzE5IDE1Ljg3IDE1Ljg3IDE5IDEyIDE5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GpsNotFixed = createIcon('GpsNotFixed', [
  [
    'path',
    {
      d: 'M20.94 11C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C6.83 3.52 3.52 6.83 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C17.17 20.48 20.48 17.17 20.94 13H23V11H20.94ZM12 19C8.13 19 5 15.87 5 12C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19Z',
      key: 'of81v2',
    },
  ],
]);

export default GpsNotFixed;
